<template>
  <fragment>
    <b-card :class="'main'">
      <h1>Dashboard</h1>
      <b-card-group deck v-if="!user.adminUser">
        <b-card class="text-center" bg-variant="dark" text-variant="white">
          <b-link
            :to="{ name: 'Projects overview', params: { filter: 'open' } }"
          >
            <h2>{{ new_requests }}</h2>
            <div class="card-footer">{{ $t('table.filter.new_projects') }}</div>
          </b-link>
        </b-card>

        <b-card class="text-center" bg-variant="dark" text-variant="white">
          <b-link
            :to="{
              name: 'Projects overview',
              params: { filter: encodeURIComponent('pending,expired,invalid') },
            }"
          >
            <h2>{{ pending_quotes }}</h2>
            <div class="card-footer">
              {{ $t('table.filter.awaiting_quote') }}
            </div>
          </b-link>
        </b-card>

        <b-card class="text-center" bg-variant="dark" text-variant="white">
          <b-link
            :to="{ name: 'Projects overview', params: { filter: 'won' } }"
          >
            <h2>{{ won_requests }}</h2>
            <div class="card-footer">{{ $t('table.filter.won') }}</div>
          </b-link>
        </b-card>
      </b-card-group>

      <b-card-group deck v-if="user.adminUser">
        <b-card class="text-center" bg-variant="dark" text-variant="white">
          <b-link :to="{ name: 'Manage projects' }">
            <b-icon icon="chat-right-text" scale="3" />
            <div class="card-footer">Manage projects</div>
          </b-link>
        </b-card>
      </b-card-group>
    </b-card>

    <!-- <b-card :header="$t('user.payment.account_balance')" v-if="!user.adminUser">
      <b-list-group flush>
        <b-list-group-item><h3>{{ user.balance / 100 | currency(user.currency) }}</h3></b-list-group-item>
      </b-list-group>
  </b-card> -->
  </fragment>
</template>
<script>
import api from '../api/api';

export default {
  mounted() {
    this.getProvisionLeads();
  },
  metaInfo() {
    return {
      title: 'Dashboard',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      new_requests: 0,
      pending_quotes: 0,
      won_requests: 0,
    };
  },
  methods: {
    getProvisionLeads() {
      api.getProvisionLeads().then((res) => {
        this.new_requests = res.data.filter(
          (lead) => lead.status === 'open',
        ).length;
        this.pending_quotes = res.data.filter(
          (lead) => lead.status === 'pending',
        ).length;
        this.won_requests = res.data.filter(
          (lead) => lead.status === 'won',
        ).length;
      });
    },
  },
};
</script>
<style lang="scss" src="../assets/scss/dashboard.scss" scoped />
